import { Component, OnDestroy, OnInit, Input } from '@angular/core';
import { ProgressBarService } from '../../services/progress-bar.service';

@Component({
  selector: 'dt-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss']
})
export class ProgressBarComponent implements OnInit, OnDestroy {

  @Input() setting!: { borderRadius: string };

  // defaultSetting = {
  //   borderRadius: '6px 6px 0 0'
  // }

  constructor(public progressBarService: ProgressBarService) { }

  ngOnInit(): void {
    this.progressBarService.progress = 0;


    if (!this.setting) {
      this.setting = {
        borderRadius: '6px 6px 0 0'
      };
    }
  }

  ngOnDestroy(): void {
    this.progressBarService.clear();
  }

}
